import React from 'react'
import './contact.scss'

const Contact = () => {
  return (
    <div className='contact'>
        

        <div className="form-container">
            <div className="form-left">
                <h2>We'd love to hear from you</h2>
                <p>We're just one click away to help you take your brand or product from great to incredible. Fill in the form to share more details about your project. Or your favorite gum flavor. Either way, we’d love to talk.</p>

            </div>
            <div className="form-right">
                <input type="text" placeholder="Name" />
                <input type="email" placeholder="Email" />
                <input type="text" placeholder="Message" />
                <button>Submit</button>
            </div>
        </div>

    </div>
  )
}

export default Contact